module.exports = __webpack_public_path__ + "static/img/img03.04eb405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsCenter/img/img03.jpg
// module id = o6Ba
// module chunks = 1